/*
  Brand of the Month — section behaviour.

  Was inlined per section instance; the homepage places this section 3x, so the
  same ~7.6 KB shipped three times inside the HTML document. As an asset it is
  fetched and parsed once, then applied to every .bm section on the page.
*/
(function () {
  if (window.__bqBrandSectionLoaded) return;
  window.__bqBrandSectionLoaded = true;

  function initBrandSection(section) {
    if (!section || section.dataset.bmInit) return;
    section.dataset.bmInit = '1';

  function qsa(sel, ctx) { return Array.from((ctx || section).querySelectorAll(sel)); }

  var track   = section.querySelector('.bm__track');
  var dotsEl  = section.querySelector('.bm__dots');
  var btnPrev = section.querySelector('.bm__arrow--prev');
  var btnNext = section.querySelector('.bm__arrow--next');
  var cards   = track ? qsa('.bm__card', track) : [];

  function cardStep() {
    if (!cards.length) return 200;
    var gap = 12;
    return cards[0].offsetWidth + gap;
  }

  function updateArrows() {
    if (!track || !btnPrev || !btnNext) return;
    var maxScroll = track.scrollWidth - track.clientWidth - 2;
    btnPrev.disabled = track.scrollLeft <= 2;
    btnNext.disabled = track.scrollLeft >= maxScroll;
  }

  function scrollByDir(dir) {
    if (!track) return;
    track.scrollBy({ left: dir * cardStep(), behavior: 'smooth' });
  }

  if (btnPrev) btnPrev.addEventListener('click', function () { scrollByDir(-1); });
  if (btnNext) btnNext.addEventListener('click', function () { scrollByDir(1); });
  if (track) {
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
  }

  function buildDots() {
    if (!dotsEl) return;
    dotsEl.innerHTML = '';
    if (window.innerWidth > 599) return;
    cards.forEach(function (_, i) {
      var d = document.createElement('button');
      d.className = 'bm__dot' + (i === 0 ? ' is-active' : '');
      d.setAttribute('aria-label', 'Go to item ' + (i + 1));
      d.addEventListener('click', function () {
        if (cards[i]) track.scrollTo({ left: cards[i].offsetLeft - 16, behavior: 'smooth' });
      });
      dotsEl.appendChild(d);
    });
  }

  function updateDots() {
    if (window.innerWidth > 599 || !dotsEl) return;
    var dots = qsa('.bm__dot', dotsEl);
    var closest = 0, minDiff = Infinity;
    cards.forEach(function (c, i) {
      var diff = Math.abs(c.offsetLeft - 16 - track.scrollLeft);
      if (diff < minDiff) { minDiff = diff; closest = i; }
    });
    dots.forEach(function (d, i) { d.classList.toggle('is-active', i === closest); });
  }

  if (track) track.addEventListener('scroll', updateDots, { passive: true });
  buildDots();
  window.addEventListener('resize', function () { buildDots(); updateArrows(); });

    var SID = section.id.replace(/^bm-/, '');
  var modal = document.getElementById('bm-qv-modal-' + SID);
  var qvImg = document.getElementById('bm-qv-img-' + SID);
  var qvThumbs = document.getElementById('bm-qv-thumbs-' + SID);
  var qvVendor = document.getElementById('bm-qv-vendor-' + SID);
  var qvTitle = document.getElementById('bm-qv-title-' + SID);
  var qvPrice = document.getElementById('bm-qv-price-' + SID);
  var qvWas = document.getElementById('bm-qv-was-' + SID);
  var qvVariants = document.getElementById('bm-qv-variants-' + SID);
  var qvDesc = document.getElementById('bm-qv-desc-' + SID);
  var qvAtc = document.getElementById('bm-qv-atc-' + SID);
  var qvLink = document.getElementById('bm-qv-link-' + SID);
  var activeVid = null;

  function openQV(btn) {
    var d = btn.dataset;
    qvVendor.textContent = d.qvVendor || '';
    qvTitle.textContent = d.qvTitle || '';
    qvPrice.textContent = d.qvPrice || '';
    qvDesc.textContent = d.qvDescription || '';
    qvLink.href = d.qvUrl || '#';
    qvWas.textContent = d.qvHasCompare === 'true' ? d.qvCompare : '';
    qvWas.style.display = d.qvHasCompare === 'true' ? '' : 'none';

    var imgs = [d.qvImage].concat(d.qvImage2 ? [d.qvImage2] : []);
    qvImg.src = imgs[0] || '';
    qvImg.alt = d.qvTitle || '';
    qvThumbs.innerHTML = '';
    if (imgs.length > 1) {
      imgs.forEach(function (src, i) {
        var tb = document.createElement('button');
        tb.className = 'bm-qv__thumb' + (i === 0 ? ' is-active' : '');
        tb.innerHTML = '<img src="' + src + '" alt="" width="56" height="56" loading="lazy">';
        tb.addEventListener('click', function () {
          qvImg.src = src;
          qvThumbs.querySelectorAll('.bm-qv__thumb').forEach(function (t) { t.classList.remove('is-active'); });
          tb.classList.add('is-active');
        });
        qvThumbs.appendChild(tb);
      });
    }

    qvVariants.innerHTML = '';
    activeVid = d.qvVariantId || null;
    var vcount = parseInt(d.qvVcount || '0', 10);
    if (vcount > 1) {
      var lbl = document.createElement('span');
      lbl.className = 'bm-qv__variant-label';
      lbl.textContent = 'Options';
      qvVariants.appendChild(lbl);
      var wrap = document.createElement('div');
      wrap.className = 'bm-qv__pills';
      for (var i = 0; i < vcount; i++) {
        (function (i) {
          var raw = d['qvV' + i]; if (!raw) return;
          var parts = raw.split('|');
          var vid = parts[0], label = parts[1] || '', avail = parts[2] !== 'false', vp = parts[3] || '';
          var pill = document.createElement('button');
          pill.className = 'bm-qv__pill' + (i === 0 ? ' is-active' : '') + (!avail ? ' is-unavailable' : '');
          pill.textContent = label;
          pill.disabled = !avail;
          if (i === 0) activeVid = vid;
          pill.addEventListener('click', function () {
            if (!avail) return;
            wrap.querySelectorAll('.bm-qv__pill').forEach(function (p) { p.classList.remove('is-active'); });
            pill.classList.add('is-active');
            activeVid = vid;
            qvPrice.textContent = vp;
            qvAtc.disabled = false;
            qvAtc.textContent = 'Add To Cart';
          });
          wrap.appendChild(pill);
        })(i);
      }
      qvVariants.appendChild(wrap);
    }

    var available = d.qvAvailable !== 'false';
    qvAtc.disabled = !available;
    qvAtc.textContent = available ? 'Add To Cart' : 'Sold Out';
    modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
  }

  function closeQV() {
    modal.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }

  if (modal) {
    modal.querySelector('.bm-qv__backdrop').addEventListener('click', closeQV);
    modal.querySelector('.bm-qv__close').addEventListener('click', closeQV);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hasAttribute('hidden')) closeQV();
    });
    qvAtc.addEventListener('click', function () {
      if (!activeVid || qvAtc.disabled) return;
      var orig = qvAtc.textContent;
      qvAtc.textContent = 'Adding…';
      qvAtc.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(activeVid, 10), quantity: 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        qvAtc.textContent = 'Added ✓';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(function () { qvAtc.textContent = orig; qvAtc.disabled = false; closeQV(); }, 1600);
      })
      .catch(function () { qvAtc.textContent = orig; qvAtc.disabled = false; });
    });
  }

  section.addEventListener('click', function (e) {
    var qvBtn = e.target.closest('.bm__qv-btn');
    if (qvBtn) { e.preventDefault(); e.stopPropagation(); openQV(qvBtn); return; }
    var qsBtn = e.target.closest('.bm__quick-select');
    if (qsBtn) { e.preventDefault(); e.stopPropagation(); openQV(qsBtn); return; }
  });
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(
      scope.querySelectorAll('section.bm[id^="bm-"]'),
      initBrandSection
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when a section is re-rendered.
  document.addEventListener('shopify:section:load', function (evt) {
    initAll(evt.target || document);
  });
})();
